import React, { useState } from 'react';
import {
  renderInputField,
  renderInputFieldWithTextBox,
} from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';
const ExaminationOfFemalePartner = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`examinationOfFemalePartner.${name}`, value));
  };
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'ExamOfFemalePartner',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              console.log(`data`, data);
              console.log(`uploadedFiles`, uploadedFiles);
              setUploadedFiles([...uploadedFiles, data]);
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      setUploadedFiles(
        uploadedFiles.filter((data) => data.fileId !== file.fileId),
      );
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">EXAMINATION OF FEMALE PARTNER</p>
          </div>

          <div className="body">
            <div className="card_name_container">
              {renderInputField(
                'Height',
                'partnerHeight',
                patientData.examinationOfFemalePartner.partnerHeight,
                handleInputChange,
              )}
              {renderInputField(
                'Weight',
                'partnerWeight',
                patientData.examinationOfFemalePartner.partnerWeight,
                handleInputChange,
              )}

              {renderInputField(
                'BMI',
                'partnerBMI',
                patientData.examinationOfFemalePartner.partnerBMI,
                handleInputChange,
              )}
              {renderInputField(
                'BP',
                'partnerBP',
                patientData.examinationOfFemalePartner.partnerBP,
                handleInputChange,
              )}
            </div>

            <div className="card_name_container">
              {renderInputField(
                'Pallor',
                'partnerPallor',
                patientData.examinationOfFemalePartner.partnerPallor,
                handleInputChange,
              )}
              {renderInputField(
                'Thyroid',
                'partnerThyroid',
                patientData.examinationOfFemalePartner.partnerThyroid,
                handleInputChange,
              )}
              {renderInputField(
                'Galactorrhoea',
                'partnerGalactorrhoea',
                patientData.examinationOfFemalePartner.partnerGalactorrhoea,
                handleInputChange,
              )}

              {renderInputField(
                'Hirusitism',
                'partnerHirusitism',
                patientData.examinationOfFemalePartner.partnerHirusitism,
                handleInputChange,
              )}
            </div>

            <div className="card_name_container">
              {renderInputFieldWithTextBox(
                'partnerAbdominalExamination',
                patientData.examinationOfFemalePartner
                  .partnerAbdominalExamination,
                handleInputChange,
                '',
                'Abdominal examination',
              )}
              {renderInputFieldWithTextBox(
                'partnerSpeculumExamination',
                patientData.examinationOfFemalePartner
                  .partnerSpeculumExamination,
                handleInputChange,
                '',
                'Speculum examination',
              )}

              {renderInputFieldWithTextBox(
                'partnerVaginalExamination',
                patientData.examinationOfFemalePartner
                  .partnerVaginalExamination,
                handleInputChange,
                '',
                'Vaginal examination',
              )}
            </div>
            {/* <div style={{ paddingTop: '50px' }}>
              <div className="row clearfix">
                <FileUploadCard
                  setFiles={setFiles}
                  setUploadedFiles={setUploadedFiles}
                  files={uploadedFiles}
                  handleUpload={handleUpload}
                  id={patientId}
                />
                {uploadedFiles.map((data, i) => {
                  console.log('uploadedFiles', uploadedFiles);
                  return (
                    <FileDocumentCard
                      key={i}
                      DocumentName={data.displayFileName}
                      DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                      DocumentDate={new Date(
                        data.updatedAt,
                      ).toLocaleDateString()}
                      ImageUrl={
                        data?.fileType?.includes('image')
                          ? data.presignedUrl
                          : undefined
                      }
                      handleDeleteFile={() => handleDeleteFile(data)}
                      file={data}
                      fileUniquePrefix={`patient-${patientId}`}
                    />
                  );
                })}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExaminationOfFemalePartner;
